import withDraft from '@/utils/draftHelper';
import { removeItemByCode } from '@/utils/resultsHelper';
import actions from '../../settings/constants';
import { findCatalogue } from './state';

const closeDatasetSettings = withDraft((draft, action) => {
  const item = findCatalogue(draft, action);
  if (item) {
    draft.catalogues[action.category].results = removeItemByCode(draft.catalogues[action.category].results, item);
  }
});

export default {
  [actions.CLOSE_DATASET_SETTINGS]: closeDatasetSettings,
};
